var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn',{attrs:{"cssClass":"btn btn-secondary","icon":"fas fa-cloud-download-alt","click":_vm.downloadCsv}})
}
var staticRenderFns = []

export { render, staticRenderFns }